let e=function(e){return e.CONNECTED="connected",e.DISCONNECTED="disconnected",e.LOADED="loaded",e.JS_LOADED="js-loaded",e.CSS_LOADED="css-loaded",e.FAILED="failed",e}({});export{e as VCMFEventType};
//# sourceMappingURL=webComponentWrapper.types.js.map
